import React, {Component} from 'react';
import {withRouter} from "react-router";
import {translate} from 'react-i18next';

import '../../css/main.scss';

class Network extends Component {
    render() {
        const {t} = this.props;
        return (
            <>
                <center>
                    <div className={'s404-container'} style={{marginTop: 100}}>
                        404
                    </div>

                    <div className={'text'}>
                        {t('text')}
                    </div>
                </center>
            </>
        )
    }
}

export default withRouter(translate('404')(Network));
